
import { useUiStore } from "@/store/ui";
import { useTranslation } from "react-i18next";
import { Logo } from "@/components/brand/logo";

/**
 * Shared footer shown on every authenticated screen.
 * Phase 4 redesign: removed all app-feature items and external social
 * media icons/links. Only copyright + legal links remain, matching the
 * landing page footer. Sticky to the bottom via the parent's flex column.
 *
 * Mobile note: the fixed BottomNav (≈56px + safe-area) AND the dismissible
 * PwaInstallBanner (≈60px, sits above the BottomNav) both overlay the bottom
 * of the viewport on mobile. We add pb-32 (128px) on mobile to lift the
 * footer's content above both. Desktop has neither → normal pb-5.
 */
export function AppFooter() {
  const navigate = useUiStore((s) => s.navigate);
  const { t } = useTranslation();

  return (
    <footer className="mt-auto border-t border-border/60 bg-muted/30">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-3 px-4 py-5 pb-32 text-xs text-muted-foreground sm:flex-row md:pb-5">
        <div className="flex items-center gap-2">
          <Logo className="h-4 w-4" />
          <span className="font-semibold text-foreground">
            {t("landing.footerLegal.copyright")}
          </span>
          <span className="hidden sm:inline">· <span className="text-gold font-medium">v1.0.0</span></span>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5">
          <button onClick={() => navigate("legal/privacy")} className="hover:text-foreground hover:underline">
            {t("landing.footerLegal.privacy")}
          </button>
          <button onClick={() => navigate("legal/terms")} className="hover:text-foreground hover:underline">
            {t("landing.footerLegal.terms")}
          </button>
          <button onClick={() => navigate("legal/data-protection")} className="hover:text-foreground hover:underline">
            {t("landing.footerLegal.dataProtection")}
          </button>
          <button onClick={() => navigate("legal/support")} className="hover:text-foreground hover:underline">
            {t("landing.footerLegal.helpSupport")}
          </button>
        </nav>
      </div>
    </footer>
  );
}
